'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _PropTypes = require('../../lib/PropTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SuiTab',
  props: {
    menu: {
      type: Object,
      default: function _default() {
        return {
          attached: true,
          tabular: true
        };
      }
    },
    menuPosition: (0, _PropTypes.Enum)(['left', 'right'], {
      description: 'Menu Position'
    }),
    activeIndex: {
      type: [String, Number],
      default: 0
    }
  },
  data: function data() {
    return {
      tabs: [],
      activeTab: null
    };
  },
  computed: {
    tabMenu: function tabMenu() {
      var _this = this;

      var h = this.$createElement;

      return h(
        'sui-menu',
        { props: this.menu },
        [this.tabs.map(function (tab) {
          return h(
            'a',
            {
              'class': ['item', { active: tab.active, disabled: tab.disabled }],
              on: {
                'click': function click(e) {
                  return _this.openTab(e, tab);
                }
              }
            },
            [tab.icon && h(
              'sui-icon',
              {
                attrs: { name: tab.icon }
              },
              []
            ), h(
              'span',
              null,
              [tab.title]
            ), tab.label && h(
              'sui-label',
              null,
              [tab.label]
            )]
          );
        })]
      );
    }
  },
  watch: {
    activeIndex: function activeIndex(newIndex) {
      this.openTab(null, this.tabs[+newIndex]);
    }
  },
  mounted: function mounted() {
    if (!this.tabs.length) {
      throw new Error('tab used without tab-pane');
    }

    var pane = this.tabs[this.activeIndex] || this.tabs[0];
    pane.open();

    this.activeTab = pane;
  },

  methods: {
    addTab: function addTab(tab) {
      this.tabs.push(tab);
    },
    openTab: function openTab(e, tab) {
      if (tab.disabled) {
        return;
      }

      this.activeTab.close();
      tab.open();

      var index = this.tabs.indexOf(tab);

      this.$emit('change', e, tab, index);
      this.$emit('update:activeIndex', index);

      this.activeTab = tab;
    }
  },
  render: function render() {
    var h = arguments[0];

    var slot = this.$slots.default;

    var renderable = [this.tabMenu, slot];

    if (this.menu.attached === 'bottom') {
      renderable.reverse();
    }

    if (this.menu.vertical) {
      renderable = [h(
        'sui-grid-column',
        {
          attrs: { width: 4 }
        },
        [this.tabMenu]
      ), h(
        'sui-grid-column',
        {
          attrs: { width: 12 },
          'class': 'stretched' },
        [slot]
      )];

      if (this.menu.tabular === 'right' || this.menuPosition === 'right') {
        renderable.reverse();
      }

      renderable = h(
        'sui-grid',
        null,
        [h(
          'sui-grid-row',
          null,
          [renderable]
        )]
      );
    }

    return h(
      'div',
      null,
      [Array.isArray(renderable) ? [].concat((0, _toConsumableArray3.default)(renderable)) : renderable]
    );
  }
};